import React from 'react';
import './SidePanel.css';
import SaveButton from './SaveButton';

const SidePanel = ({
  isVisible,
  togglePanel,
  autoLayout,
  onCreateNew,
  onSave,
  currentChartId,
  currentUser,
  viewMode,
  isProcessing,
  deleteZoneRef,
  onNodeDragStart,
  onNodeDragStop,
  isDeleteZoneActive,
  isOverDeleteZone,
}) => {
  const onDragStart = (event, nodeType) => {
    event.dataTransfer.setData('application/reactflow', nodeType);
    event.dataTransfer.effectAllowed = 'move';
  };

  return (
    <>
      <button
        onClick={togglePanel}
        className={`palette-toggle-button ${isVisible ? 'open' : 'closed'}`}
        style={{ left: isVisible ? '219px' : '-1px',
                 zIndex: isDeleteZoneActive ? 5 : 25,
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ transform: isVisible ? 'rotate(0deg)' : 'rotate(180deg)', transition: 'transform 0.2s ease-in-out' }}
        >
          <polyline points="15 18 9 12 15 6" />
        </svg>
      </button>
      <aside
        ref={deleteZoneRef}
        className={`sidePanel ${!isVisible ? 'hidden' : ''} ${isDeleteZoneActive ? 'deleteZone' : ''} ${isOverDeleteZone ? 'drag-over' : ''}`}
      >
        {isDeleteZoneActive ? (
          <div className="deleteZoneOverlay">
            <div className="deleteZoneContent">
              <p>要素を削除</p>
            </div>
          </div>
        ) : (
          <div className="sidePanelContent">
            <button
              onClick={onCreateNew}
              className="sidePanelButton btnPrimary"
              style={{
                marginTop: "5px"
              }}
            >
              新規作成
            </button>
            {currentUser && (
              <SaveButton
                onSave={onSave}
                currentChartId={currentChartId}
                disabled={!currentUser}
                style={{
                  marginBottom: "10px"
                }}
              />
            )}

            {viewMode === 'flow' && (
              <>
                <h3>要素を追加</h3>
                <div className="paletteNodeContainer">
                  <div
                    className="paletteNode"
                    onDragStart={(e) => onDragStart(e, '主張')}
                    draggable
                    style={{ borderLeftColor: '#f28482' }}
                  >
                    主張
                  </div>
                  <div
                    className="paletteNode"
                    onDragStart={(e) => onDragStart(e, '根拠')}
                    draggable
                    style={{ borderLeftColor: '#84a9f4' }}
                  >
                    根拠
                  </div>
                  <div
                    className="paletteNode"
                    onDragStart={(e) => onDragStart(e, '具体例')}
                    draggable
                    style={{ borderLeftColor: '#f6bd60' }}
                  >
                    具体例
                  </div>
                  <div
                    className="paletteNode"
                    onDragStart={(e) => onDragStart(e, '結論')}
                    draggable
                    style={{ borderLeftColor: '#90be6d' }}
                  >
                    結論
                  </div>
                </div>

                <hr className="divider" />

                <button
                  onClick={autoLayout}
                  disabled={isProcessing}
                  className="sidePanelButton btnSecondary"
                >
                  自動レイアウト
                </button>
              </>
            )}
          </div>
        )}
      </aside>
    </>
  );
};

export default SidePanel;
